import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { createQuickMenu } from "../../Services/MenuApi";

// Shown when a scanned barcode matches no product, so the cashier can create
// it on the spot (title + price + category) without leaving the POS screen.
const QuickAddProductModal = ({
  open,
  barcode,
  categories = [],
  organisationId,
  onClose,
  onCreated,
}) => {
  const { t } = useTranslation();
  const [titre, setTitre] = useState("");
  const [prix, setPrix] = useState("");
  const [categorie, setCategorie] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setTitre("");
      setPrix("");
      setCategorie("");
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!titre.trim()) {
      toast.error(t("Veuillez entrer un nom de produit."));
      return;
    }
    const parsedPrix = parseFloat(prix);
    if (!parsedPrix || parsedPrix <= 0) {
      toast.error(t("Veuillez entrer un prix valide."));
      return;
    }

    setSaving(true);
    try {
      const res = await createQuickMenu({
        categorie: categorie || undefined,
        code_barre: barcode,
        libelle: titre.trim(),
        prix: parsedPrix,
        organisation_id: organisationId,
      });
      if (res.data.success) {
        toast.success(t("Produit créé avec succès."));
        onCreated(res.data.data);
      } else {
        toast.error(res.data.errorMessage || t("Erreur lors de la création du produit."));
      }
    } catch (error) {
      toast.error(
        error.response?.data?.errorMessage ||
          t("Erreur lors de la création du produit."),
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="modal fade show d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">
                {t("Créer un nouveau produit")}
              </h5>
              <button
                type="button"
                className="btn btn-primary p-0"
                onClick={onClose}
                style={{
                  backgroundColor: "red",
                  width: "24px",
                  height: "24px",
                }}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label className="font-weight-700">{t("Titre")}</label>
                <input
                  type="text"
                  className="form-control"
                  value={titre}
                  onChange={(e) => setTitre(e.target.value)}
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label className="font-weight-700">{t("Prix")}</label>
                <input
                  type="number"
                  step="0.001"
                  min="0"
                  className="form-control"
                  value={prix}
                  onChange={(e) => setPrix(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label className="font-weight-700">{t("Catégorie")}</label>
                <select
                  className="form-control"
                  value={categorie}
                  onChange={(e) => setCategorie(e.target.value)}
                >
                  <option value="">{t("Aucune")}</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat.libelle?.fr}>
                      {cat.libelle?.fr}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label className="font-weight-700">{t("Code-barres")}</label>
                <input
                  type="text"
                  className="form-control"
                  value={barcode}
                  disabled
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={saving}
              >
                {t("Annuler")}
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={saving}
              >
                {saving ? t("Enregistrement...") : t("Enregistrer")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default QuickAddProductModal;
